/**
 * WordPress dependencies
 */
import { createContext, useContext } from '@wordpress/element';

/**
 * Internal dependencies
 */

export const CompositeContext = createContext({});
CompositeContext.displayName = 'CompositeContext';
export const useCompositeContext = () => useContext(CompositeContext);